<div class="footer-content d-md-flex justify-content-between align-items-center">
    <div class="mt-2">
        <a href="#" class="text-gray me-3">Terms &amp; Conditions</a>
        <a href="#" class="text-gray">Privacy &amp; Policy</a>
    </div>
    <div class="d-flex align-items-center">
        <p class="mb-0 me-2">Copyright © 2024 Lexipack. All rights reserved.</p>
        <a href="https://compubrain.com/" target="_blank">
            <img src="assets/images/footer/CompuBrain_Monogram.png" alt="CompuBrain Monogram" title="Developed by CompuBrain" class="mb-4">
        </a>
    </div>
</div>
